import api from '../../../services/api';
import {
  Conversation,
  ConversationCreateData,
  ConversationUpdateData,
  ConversationListResponse,
  MessageListResponse,
  SendMessageRequest,
  SendMessageResponse,
  ApiResponse,
} from '@kifuerpflege/shared';

/**
 * Create a new conversation
 */
export async function createConversation(
  data: ConversationCreateData
): Promise<Conversation> {
  const response = await api.post<ApiResponse<Conversation>>(
    '/conversations',
    data
  );

  return response.data.data!;
}

/**
 * Get conversation by ID
 */
export async function getConversation(id: string): Promise<Conversation> {
  const response = await api.get<ApiResponse<Conversation>>(
    `/conversations/${id}`
  );

  return response.data.data!;
}

/**
 * Update conversation
 */
export async function updateConversation(
  id: string,
  data: ConversationUpdateData
): Promise<Conversation> {
  const response = await api.patch<ApiResponse<Conversation>>(
    `/conversations/${id}`,
    data
  );

  return response.data.data!;
}

/**
 * Delete conversation
 */
export async function deleteConversation(id: string): Promise<void> {
  await api.delete(`/conversations/${id}`);
}

/**
 * Delete all conversations
 */
export async function deleteAllConversations(): Promise<{ deletedCount: number }> {
  const response = await api.delete<ApiResponse<{ deletedCount: number; message: string }>>(
    '/conversations/all'
  );

  return response.data.data!;
}

/**
 * List conversations
 */
export async function listConversations(params?: {
  page?: number;
  limit?: number;
  archived?: boolean;
}): Promise<ConversationListResponse> {
  const response = await api.get<ApiResponse<ConversationListResponse>>(
    '/conversations',
    { params }
  );

  return response.data.data!;
}

/**
 * Get messages for conversation
 */
export async function getConversationMessages(
  conversationId: string,
  params?: {
    cursor?: string;
    limit?: number;
  }
): Promise<MessageListResponse> {
  const response = await api.get<ApiResponse<MessageListResponse>>(
    `/conversations/${conversationId}/messages`,
    { params }
  );

  return response.data.data!;
}

/**
 * Send a message (REST fallback)
 */
export async function sendMessage(
  conversationId: string,
  data: SendMessageRequest
): Promise<SendMessageResponse> {
  const response = await api.post<ApiResponse<SendMessageResponse>>(
    `/conversations/${conversationId}/messages`,
    data
  );

  return response.data.data!;
}
